import * as GSAP from 'gsap';
import * as EventEmitter from 'eventemitter3';
import {ViewEvent} from "../event/EventStaus";

abstract class AbstractElement {

    readonly _template: JQuery;
    public emitter: EventEmitter;
    public isTransition:boolean;

    protected constructor(template: JQuery) {
        this._template = template;
        this.emitter = new EventEmitter();
        this.isTransition = false;
        this.init();
    }

    init(): void {
    }

    resize(): void {
    }

    reset(): void {
    }

    update(scrollTop?: number): void {
    }

    transitionIn(): void {

        this.resize();
        GSAP.TweenMax.killTweensOf(this);
        GSAP.TweenMax.set(this.template, {alpha: 0});
        GSAP.TweenMax.to(this.template, 0.3, {
            alpha: 1,
            ease: GSAP.Circ.easeIn,
            onComplete: () => {
                this.onTransitionCompleted(ViewEvent.ON_TRANSITION_IN_COMPLETED);
            }
        });
    }

    transitionOut(arg: any = {}): void {

        GSAP.TweenMax.killTweensOf(this);
        GSAP.TweenMax.to(this.template, 0.3, {
            alpha: 0,
            ease: GSAP.Circ.easeOut,
            onComplete: () => {
                this.onTransitionCompleted(ViewEvent.ON_TRANSITION_OUT_COMPLETED, arg)
            }
        });
    }

    onTransitionCompleted(type: string, arg: any = {}): void {

        if (type === ViewEvent.ON_TRANSITION_IN_COMPLETED) {
        }
        if (type === ViewEvent.ON_TRANSITION_OUT_COMPLETED) {
            this.reset();
        }
        arg.type = type;
        this.emitter.emit(type, arg);
    }

    get template(): JQuery {
        return this._template;
    }
}

export default AbstractElement;